import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";

const Projects = () => {
    const [projects, setProjects] = useState([]);
    useEffect(() => {
        fetch("/projectsData.json")
            .then((res) => res.json())
            .then((data) => setProjects(data));
    }, []);

    return (
        <div className="container-fluid banner">
            <div className="container">
                <h2 className="text-center text-warning text-uppercase my-3">
                    My Recent Projects
                </h2>
                <div className="row">
                    {projects.map((project) => (
                        <div className="col-sm-6 col-md-4 mb-5" data-aos="fade-right">
                            <div className="profile-card">
                                <div className="profile-img">
                                    <img
                                        style={{ height: "400px" }}
                                        src={project.img1}
                                        alt="Team"
                                    />
                                </div>
                                <div className="profile-content">
                                    <h6 className="title text-white">
                                        {project?.title}
                                    </h6>
                                    <ul className="social-link">
                                        <li>
                                            <Link
                                                to={`/project/${project.id}`}
                                                className="cta rounded-pill"
                                            >
                                                <span>Details</span>
                                                <svg width="12px" height="10px" viewBox="0 0 13 10">
                                                    <path d="M1,5 L11,5"></path>
                                                    <polyline points="8 1 12 5 8 9"></polyline>
                                                </svg>
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <hr style={{ color: "white", width: "800px", margin: "20px auto" }} />
        </div>
    );
};

export default Projects;